import { LightningElement, api } from "lwc";
import { Config } from "./types";

export default class Search extends LightningElement {
  @api config: Config = null!;

  private query: string | null = null;
  private initValue: string | null = null;

  private get searchUrl() {
    return this.config.searchUrl;
  }

  connectedCallback() {
    const url = new URL(window.location.href);
    this.initValue = url.searchParams.get("keywords");
  }

  private handleChange(e: CustomEvent) {
    if (e.detail === "") {
      this.initValue = "";
    }
    this.query = e.detail;
  }

  private handleKeyPress(e: KeyboardEvent) {
    if (e.key === "Enter" && this.query) {
      const form = this.template.querySelector("form")!;
      (form as HTMLFormElement).submit();
    }
  }
}
